<template>
  <Loading :loading="loading">
    <template>
      <LazyLoadingWrapper
        :loading="loadMoreLoading"
        :loadMore="loadMore"
        :isEmpty="firstLoaded && !itemsFiltered.length && !loading"
        :emptyImage="$config.images.shared.redesign.empty.history"
        :emptyText="$lang.history_empty_text"
        scrollDistance="700"
      >
        <template>
          <b-row class="parvandeh-role-history">
            <b-col
              cols="12"
              class="parvandeh-role-history__box"
              v-for="(item, index) in itemsFiltered"
              :key="`a-${index}`"
            >
              <div class="parvandeh-role-history__header">
                <div class="parvandeh-role-history__header-right-box">
                  <span class="parvandeh-role-history__icon">
                    <mdicon name="account-outline" size="16" />
                  </span>
                  <span class="parvandeh-role-history__header-title">
                    {{ item.createdBy }}
                  </span>
                </div>
                <div class="parvandeh-role-history__header-left-box">
                  <span class="parvandeh-role-history__icon">
                    <mdicon name="clock-outline" size="16" />
                  </span>
                  <span
                    class="parvandeh-role-history__header-title"
                    v-html="item.createdAt"
                  />
                </div>
              </div>
              <div class="parvandeh-role-history__body">
                <div class="parvandeh-role-history__body-right-box">
                  <div class="parvandeh-role-history__body-title">
                    {{ $lang.new_roles }}
                  </div>
                  <div class="parvandeh-role-history__roles">
                    {{ item.newRoles }}
                  </div>
                </div>
                <div class="parvandeh-role-history__body-left-box">
                  <div class="parvandeh-role-history__body-title">
                    {{ $lang.old_roles }}
                  </div>
                  <div class="parvandeh-role-history__roles">
                    {{ item.oldRoles }}
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
        </template>
      </LazyLoadingWrapper>
    </template>
  </Loading>
</template>

<script>
import LazyLoadingWrapper from "@/components/re-design/lazy-loading-wrapper/LazyLoadingWrapper.vue";
import Loading from "./Loading.vue";
import { pathOr } from "ramda";
import { createDateFormat, generateError } from "@/shared/utils";
import { getAllParvandehRoleHistory } from "@/modules/profile/services";
import { computed, onMounted, ref, toRefs, watch } from "vue";

export default {
  components: { LazyLoadingWrapper, Loading },
  props: {
    parvandehCode: {
      type: [String, Number],
      default: null,
    },
  },
  setup(props, { emit }) {
    // generate props data
    const { parvandehCode } = toRefs(props);

    // generate items
    const firstLoaded = ref(false);
    const loading = ref(false);
    const loadMoreLoading = ref(false);
    const paging = ref({
      total: 0,
      count: 0,
      totalPages: 0,
      currentPage: 1,
      perPage: 20,
    });
    const roleHistoryItems = ref([]);
    const getItems = async () => {
      try {
        const response = await getAllParvandehRoleHistory(
          parvandehCode.value,
          paging.value.currentPage,
          paging.value.perPage
        );

        const { total, count, totalPages, currentPage, perPage, items } =
          response;
        paging.value = {
          total,
          count,
          totalPages,
          currentPage,
          perPage,
        };
        return items;
      } catch (error) {
        generateError(error);
      }
    };
    const fetchData = async () => {
      try {
        paging.value = {
          total: 0,
          count: 0,
          totalPages: 0,
          currentPage: 1,
          perPage: 20,
        };
        loading.value = true;
        const items = await getItems();
        roleHistoryItems.value = [...items];
      } catch (error) {
        generateError(error);
      } finally {
        loading.value = false;
        firstLoaded.value = true;
      }
    };
    const loadMore = async () => {
      // load more data and pushed to list
      if (!firstLoaded.value) return;
      if (loading.value || loadMoreLoading.value) return;
      if (paging.value.currentPage >= paging.value.totalPages) return;

      try {
        loadMoreLoading.value = true;
        paging.value.currentPage = paging.value.currentPage + 1;
        const items = await getItems();
        roleHistoryItems.value = [...roleHistoryItems.value, ...items];
      } catch (error) {
        generateError(error);
      } finally {
        loadMoreLoading.value = false;
      }
    };
    const itemsFiltered = computed(() => {
      return roleHistoryItems.value.map((item) => {
        const createdBy = pathOr("", ["created_by"], item);
        const createdAt = createDateFormat(
          pathOr("", ["created_at", "jalali"], item)
        );
        const newRoles = pathOr([], ["new_role"], item).join(" - ");
        const oldRoles = pathOr([], ["old_role"], item).join(" - ");
        return { createdBy, createdAt, newRoles, oldRoles };
      });
    });

    // fetched data when mounted component
    onMounted(() => fetchData());

    const close = () => emit("close");

    // return data to be used in template
    return {
      firstLoaded,
      loading,
      loadMoreLoading,
      itemsFiltered,
      loadMore,
      close,
    };
  },
};
</script>
